import { attr } from '@ember-data/model';
import { equal } from 'macro-decorators';
import Super from './document-request';

export default class DocumentRequestConsentDocument extends Super {
  documentIcon = 'file-text';
  mixpanelType = 'Consent';

  @attr() documentType;
  @attr() documentExt;
  @attr() documentMimeType;
  @attr() documentBody;
  @equal('documentType', 'text') isText;
}
